import React from 'react';
import { ChevronUp } from 'lucide-react';

const SortableHeader = ({ children, label, sortKey, currentSortKey, sortDirection, onSort, width }) => {
  const isActive = currentSortKey === sortKey;
  return (
    <th
      className="text-left py-3 px-4 text-gray-600 cursor-pointer hover:bg-gray-100 transition-colors select-none align-top font-medium"
      style={{ width }}
      onClick={() => onSort?.(sortKey)}
      title={label || (typeof children === 'string' ? children : '')}
    >
      <div className="flex items-center gap-2">
        <span>{children}</span>
        <ChevronUp size={16} className={`transition-transform duration-200 ${isActive ? 'text-indigo-600' : 'opacity-30'} ${isActive && sortDirection === 'desc' ? 'rotate-180' : ''}`} />
      </div>
    </th>
  );
};

export default SortableHeader;
